// Control de acceso y roster del módulo "Colaboración en Equipos de Trabajo".
//
// El módulo es un espacio de demo (Kit Digital) restringido a un conjunto FIJO
// de usuarios: solo estas personas lo ven en el menú, pueden entrar por ruta y
// son además las únicas seleccionables como miembros de un equipo.
//
// Módulo de constantes PURO (sin imports de Firebase) para poder usarlo tanto
// en el Sidebar/guard de ruta como en la capa de datos sin arrastrar peso.

export const USUARIOS_COLABORACION = [
  { email: "andrea.carceles@gruposecoex.com", nombre: "Andrea Cárceles" },
  { email: "maribel.fernandez@gruposecoex.com", nombre: "Maribel Fernández" },
  { email: "jose.aranda@gruposecoex.com", nombre: "José Aranda" },
  { email: "franpineiromartinez@gmail.com", nombre: "Fran Piñeiro" },
];

export const EMAILS_COLABORACION = USUARIOS_COLABORACION.map((u) =>
  u.email.toLowerCase()
);

/**
 * ¿Puede este email acceder al módulo de colaboración? (case-insensitive)
 * @param {string|undefined|null} email
 * @returns {boolean}
 */
export const puedeAccederColaboracion = (email) =>
  !!email && EMAILS_COLABORACION.includes(String(email).toLowerCase());
